import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "@atlaskit/button/new";
import EyeOpenIcon from "@atlaskit/icon/core/eye-open";
import { Popover } from "antd";
import Textfield from "@atlaskit/textfield";
import { getIssue } from "../../../../redux/actions/jiraActions";
import {
  showPreview,
  resolveRequest,
} from "../../../../redux/actions/integrationActions";
import Mustache from "mustache";
import { isEmptyJsonObject } from "../../../../common/utils/helper";
const IssuePreviewAction = ({ action }) => {
  const [showIssueKeyInput, setShowIssueKeyInput] = useState(false);
  const [issueKey, setIssueKey] = useState("");
  const dispatch = useDispatch();
  const flow = useSelector((state) => state.integration.flow);
  const issue = useSelector((state) => state.jira.issue);

  useEffect(() => {
    if (!isEmptyJsonObject(issue) && action) {
      const url = Mustache.render(action.url ? action.url : "", issue);
      const body = Mustache.render(action.body ? action.body : "", issue);
      const headers = action.headers.map((h) => {
        return {
          key: Mustache.render(h.key ? h.key : "", issue),
          value: Mustache.render(h.value ? h.value : "", issue),
        };
      });
      dispatch(
        resolveRequest({
          method: action.method,
          url: url,
          body: body,
          headers: headers,
        })
      );
    }
  }, [flow, issue]);

  const handleClickChange = (visible) => {
    setShowIssueKeyInput(visible);
  };

  const onChange = (e) => {
    setIssueKey(e.target.value);
  };
  const onPreview = () => {
    dispatch(getIssue(issueKey));
    dispatch(showPreview(true));
  };

  const renderContent = () => {
    return (
      <>
        <span className="atlassian-theme">Issue Key </span>
        <Textfield
          name="issueKey"
          isCompact={true}
          onChange={onChange}
          value={issueKey}
        />
        <br />
        <Button appearance="primary" onClick={onPreview} isDisabled={!issueKey}>
          Preview
        </Button>
      </>
    );
  };

  return (
    <>
      <Popover
        content={renderContent()}
        title=""
        trigger="click"
        open={showIssueKeyInput}
        onOpenChange={handleClickChange}
      >
        <Button
          iconBefore={EyeOpenIcon}
          appearance="subtle"
          onClick={() => {
            setShowIssueKeyInput(!showIssueKeyInput);
          }}
        />
      </Popover>
    </>
  );
};
export default IssuePreviewAction;
